module.exports = require("core-js-pure/features/symbol");


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime-corejs3/core-js/symbol.js
// module id = 240
// module chunks = 0